window.updateSearchHTML = function(text, resultsContainer){
  if(text){
    resultsContainer.innerHTML = `
    <div class="qs_suggestions">
      <div class="search_tab"></div>
      <div class="search_tabs_content"></div>
    </div>`;
    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-quick-search-advance');
    // Completing tabs...
    const resultsMarkup_tabs = resultsMarkup.querySelector('#shopify-section-advance-search-tabs-quick');
    if (resultsMarkup_tabs) {
      const targetElement = resultsContainer.querySelector('.search_tab');
      if (targetElement) {
        while (resultsMarkup_tabs.children.length > 0) {
          targetElement.appendChild(resultsMarkup_tabs.children[0]);
        }
      }
    }

    // Completing results...
    const resultsMarkup_results = resultsMarkup.querySelector('#shopify-section-advance-search-results-quick');
    if (resultsMarkup_results) {
      const targetElementResult = resultsContainer.querySelector('.search_tabs_content');
      if (targetElementResult) {
        while (resultsMarkup_results.children.length > 0) {
          targetElementResult.appendChild(resultsMarkup_results.children[0]);
        }
      }
    }

    var check_product_count = resultsContainer.querySelectorAll('[data-search-tab-slider-qr=products] .s_product_item_list .product-item-search');
    if(check_product_count && check_product_count.length < 4){
      var fill_product = document.querySelector('.searchGroupAll_wrap .swiper-slide');
      var fill_target = resultsContainer.querySelector('[data-search-tab-slider-qr=qs_alle] .qs_r_all_left_inner');

      var block_element = document.createElement('div');
      block_element.className = 's_product_item_list_block';
      block_element.innerHTML = fill_product.querySelector('.s_r_heading').outerHTML;

      var fill_product_content = fill_product.querySelectorAll('.s_product_item_list .product-item-search');
      if(fill_product_content && fill_product_content.length > 0){
        var product_list_element = document.createElement('div');
        product_list_element.className = 's_product_item_list';

        var count_take_product = 4 - check_product_count.length;
        for (let index = 0; index < count_take_product && index < fill_product_content.length; index++) {
          var product_item_wrapper = document.createElement('div');
          product_item_wrapper.innerHTML = fill_product_content[index].outerHTML;
          product_list_element.appendChild(product_item_wrapper.firstChild);
        }
        block_element.appendChild(product_list_element);
      }
      fill_target.appendChild(block_element);
    }

    // Completing total counts...
    var product_count = 0;
    var count_product = resultsContainer.querySelector('[data-tab-count-product-quick]');
    if(count_product){
      product_count += parseInt(count_product.dataset.tabCountProductQuick);
    }
    var count_collection = resultsContainer.querySelector('[data-tab-count-collection-quick]');
    if(count_collection){
      product_count += parseInt(count_collection.dataset.tabCountCollectionQuick);
    }
    var count_acticle = resultsContainer.querySelector('[data-tab-count-article-quick]');
    if(count_acticle){
      product_count += parseInt(count_acticle.dataset.tabCountArticleQuick);
    }
    var count_page = resultsContainer.querySelector('[data-tab-count-page-quick]');
    if(count_page){
      product_count += parseInt(count_page.dataset.tabCountPageQuick);
    }
    if(product_count == 0){
      resultsContainer.classList.add('hidden');
      document.querySelector('.qs_not_found').classList.remove('hidden');
    }else{
      resultsContainer.classList.remove('hidden');
      document.querySelector('.qs_not_found').classList.add('hidden');
    }
    window.loadScriptsByAttribute('data-swiper-load');
  }
}

document.addEventListener("click", async function(event){
  if(event.target.hasAttribute('data-search-tab')){
    var search_tab = event.target.dataset.searchTab;
    var search_tab_slider = document.querySelectorAll('[data-search-tab-slider]');
    search_tab_slider.forEach(function(ele){
      if(ele.dataset.searchTabSlider == search_tab){
        ele.classList.remove('hidden');
      }else{
        ele.classList.add('hidden');
      }
    });
    if(document.querySelector(`.active[data-search-tab]`)){
      document.querySelector(`.active[data-search-tab]`).classList.remove('active');
    }
    event.target.classList.add('active');

  }else if(event.target.hasAttribute('data-search-tab-qr')){
    var search_tab = event.target.dataset.searchTabQr;
    var search_tab_slider = document.querySelectorAll('[data-search-tab-slider-qr]');
    search_tab_slider.forEach(function(ele){
      if(ele.dataset.searchTabSliderQr == search_tab){
        ele.classList.remove('hidden');
      }else{
        ele.classList.add('hidden');
      }
    });
    if(document.querySelector(`.active[data-search-tab-qr]`)){
      document.querySelector(`.active[data-search-tab-qr]`).classList.remove('active');
    }
    event.target.classList.add('active');
  }else if(event.target.hasAttribute('data-search-tab-sp')){
    var search_tab = event.target.dataset.searchTabSp;
    var search_tab_slider = document.querySelectorAll('[data-search-tab-slider-sp]');
    search_tab_slider.forEach(function(ele){
      if(ele.dataset.searchTabSliderSp == search_tab){
        ele.classList.remove('hidden');
      }else{
        ele.classList.add('hidden');
      }
    });
    if(document.querySelector(`.active[data-search-tab-sp]`)){
      document.querySelector(`.active[data-search-tab-sp]`).classList.remove('active');
    }
    event.target.classList.add('active');
  }
});